import * as XLSX from 'xlsx';

const MAX_FILE_BYTES = 5 * 1024 * 1024;

function detectDelimiter(text) {
  const firstLine =
    String(text)
      .split(/\r?\n/)
      .find((line) => line.trim()) || '';
  const counts = { ';': 0, ',': 0, '\t': 0 };
  let inQuotes = false;
  for (const ch of firstLine) {
    if (ch === '"') {
      inQuotes = !inQuotes;
      continue;
    }
    if (!inQuotes && counts[ch] !== undefined) counts[ch] += 1;
  }
  return Object.entries(counts).sort((a, b) => b[1] - a[1])[0][0] || ';';
}

function sheetToRows(workbook) {
  const sheetName = workbook.SheetNames[0];
  if (!sheetName) {
    throw new Error('empty');
  }
  const sheet = workbook.Sheets[sheetName];
  const rows = XLSX.utils.sheet_to_json(sheet, {
    defval: '',
    raw: false,
    blankrows: false,
  });
  if (!rows.length) {
    throw new Error('empty');
  }
  const headers = Object.keys(rows[0] || {});
  if (headers.length === 0) {
    throw new Error('empty');
  }
  const normalized = rows.map((row) => {
    const next = {};
    headers.forEach((header) => {
      const value = row[header];
      next[header] = value == null ? '' : String(value).trim();
    });
    return next;
  });
  return { headers, rows: normalized, sheetName };
}

export function parseSpreadsheetBuffer(buffer, { filename = '', isCsv = false } = {}) {
  let workbook;
  if (isCsv) {
    const text = new TextDecoder('utf-8').decode(buffer).replace(/^\uFEFF/, '');
    const delimiter = detectDelimiter(text);
    workbook = XLSX.read(text, { type: 'string', FS: delimiter, raw: false });
  } else {
    workbook = XLSX.read(buffer, { type: 'array', raw: false });
  }
  return { ...sheetToRows(workbook), filename };
}

export function parseSpreadsheetFile(file) {
  if (!file) {
    return Promise.reject(new Error('no_file'));
  }
  if (file.size > MAX_FILE_BYTES) {
    return Promise.reject(new Error('too_large'));
  }
  const isCsv = /\.csv$/i.test(file.name);
  const isExcel = /\.xlsx?$/i.test(file.name);
  if (!isCsv && !isExcel) {
    return Promise.reject(new Error('unsupported'));
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('read_failed'));
    reader.onload = () => {
      try {
        resolve(
          parseSpreadsheetBuffer(reader.result, {
            filename: file.name,
            isCsv,
          })
        );
      } catch (error) {
        reject(error);
      }
    };
    reader.readAsArrayBuffer(file);
  });
}

export { MAX_FILE_BYTES };
